export default __webpack_public_path__ + "static/media/template_pro__0021_6---BrynKenney.9cc798fa.png";